/* WHITE NOVEMBER — normalising the catalogue's rich text (checklist item 98).

   THE PROBLEM, measured rather than assumed. Across the 250 active products
   on 4 Sept: 247 descriptions carry heading tags; 1,296 <h4> elements are
   ordinary body paragraphs and 574 <h5> elements are small labels such as
   SIZING; 231 descriptions skip or reverse heading levels; 31 open by
   repeating the product's own name, immediately under the <h1> that already
   says it; and 81 products carry 177 spec lines that begin with a stray
   letter "o" - a Word bullet that lost its list on the way into Shopify.
   There are also empty heading shells left behind by the editor and the odd
   <meta charset> that got pasted in.

   WHY THIS IS NOT A CATALOGUE FIX. Rewriting 282 product descriptions is a
   destructive, irreversible pass over copy Bianca wrote, on the LIVE store,
   to solve a problem of presentation. This does the same job at render time:
   the panel is corrected in the browser, the catalogue is never touched, and
   deleting these two files puts everything back.

   WHY A SCRIPT IS SAFE HERE. The description lives inside an accordion panel
   that is closed on load, so nothing is on screen while this runs: there is
   no flash and nothing moves under the reader. Accessibility checkers and
   Google both work from the rendered page, which is what this produces.

   THE ONE JUDGEMENT CALL. Which headings are labels and which are body copy
   cannot be read from the tag, because the catalogue uses <h4> for prose and
   <h5> for labels - backwards from what the tags mean. So it is decided by
   shape instead: four words or fewer and under 40 characters is a label,
   anything longer is a paragraph. On this catalogue that reads SIZING and
   Details as labels and "o 30mm pendant adorned on a 50cm chain" as copy,
   which is what they are.

   A note on non-breaking spaces, which this catalogue is full of: nothing
   here special-cases them, because JavaScript's own trim() and \s already
   count U+00A0 as whitespace. An earlier version carried a regex for them
   and it was dead code. */
(function () {
  var SEL = '.wn-pdp__accs .wn-acc__panel > .t-body';
  /* A lone "o" followed by a capital or a digit. No English sentence opens
     that way; every instance in this catalogue is a lost Word bullet. */
  var BULLET = /^o\s{1,4}(?=[A-Z0-9])/;

  function norm(s) {
    return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  function isLabel(text) {
    var t = (text || '').trim();
    if (!t) return false;
    if (t.length > 40) return false;
    return t.split(/\s+/).length <= 4;
  }

  /* Empty means empty to a reader: no text, and nothing that shows on its own. */
  function isBlank(el) {
    if (el.querySelector('img, iframe, video, svg, hr, input, button')) return false;
    return !(el.textContent || '').trim();
  }

  function stripSizing(root) {
    root.querySelectorAll('[style]').forEach(function (el) {
      var s = el.getAttribute('style') || '';
      var kept = s.split(';').filter(function (rule) {
        return !/^\s*(font-size|font-family|line-height|font)\s*:/i.test(rule);
      }).join(';').trim();
      if (kept) el.setAttribute('style', kept); else el.removeAttribute('style');
    });
  }

  function convertHeadings(root) {
    root.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(function (h) {
      var p = document.createElement('p');
      p.className = isLabel(h.textContent) ? 'wn-rte__lbl' : 'wn-rte__p';
      p.innerHTML = h.innerHTML;
      h.parentNode.replaceChild(p, h);
    });
  }

  function dropBlanks(root) {
    root.querySelectorAll('p, div, span, em, strong, h1, h2, h3, h4, h5, h6').forEach(function (el) {
      if (el.parentNode && isBlank(el)) el.parentNode.removeChild(el);
    });
    root.querySelectorAll('meta, style, title').forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
    /* <br> pile-ups left where those empty shells used to be. */
    root.querySelectorAll('br + br + br').forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
  }

  /* The name, twice. Only ever the FIRST block, and only when it matches the
     product title exactly once punctuation and case are set aside - a real
     opening line that happens to begin with the name is left alone. */
  function dropDuplicateTitle(root, title) {
    var t = norm(title);
    if (!t) return;
    var first = root.firstElementChild;
    while (first && isBlank(first)) first = first.nextElementSibling;
    if (!first) return;
    if (norm(first.textContent) === t) first.parentNode.removeChild(first);
  }

  function isBulletLine(el) {
    return el && el.tagName === 'P' && BULLET.test((el.textContent || '').trim());
  }

  /* Take the "o" off the front without touching the markup around it: find
     the first text node and edit that, so bold, links and italics survive. */
  function unprefix(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (!node.nodeValue || !node.nodeValue.trim()) continue;
      node.nodeValue = node.nodeValue.replace(/^\s*/, '').replace(BULLET, '');
      return;
    }
  }

  /* Runs of two or more become a real list; a lone one just loses its "o"
     and stays a paragraph, because a one-item bullet list looks like a
     mistake. */
  function fixWordBullets(root) {
    var kids = Array.prototype.slice.call(root.children);
    var i = 0;
    while (i < kids.length) {
      if (!isBulletLine(kids[i])) { i++; continue; }
      var group = [];
      while (i < kids.length && isBulletLine(kids[i])) { group.push(kids[i]); i++; }
      if (group.length < 2) { unprefix(group[0]); continue; }
      var ul = document.createElement('ul');
      ul.className = 'wn-rte__list';
      group[0].parentNode.insertBefore(ul, group[0]);
      group.forEach(function (el) {
        unprefix(el);
        var li = document.createElement('li');
        li.innerHTML = el.innerHTML;
        ul.appendChild(li);
        el.parentNode.removeChild(el);
      });
    }
  }

  function run() {
    var title = document.querySelector('.wn-pdp__title');
    title = title ? title.textContent : '';
    document.querySelectorAll(SEL).forEach(function (root) {
      if (root.hasAttribute('data-wn-rte')) return;
      root.setAttribute('data-wn-rte', '');
      try {
        dropBlanks(root);
        dropDuplicateTitle(root, title);
        convertHeadings(root);
        fixWordBullets(root);
        stripSizing(root);
      } catch (e) {
        /* A panel that is merely untidy is better than a panel that is gone. */
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();